export default function WhatIsOnboarding() {
  const schemaSteps = [
    { title: 'Найм', desc: 'Подписание договора, оформление документов' },
    { title: 'Первый день', desc: 'Знакомство с командой, рабочее место, welcome-пакет' },
    { title: 'Первая неделя', desc: 'Вводное обучение, чек-листы, знакомство с процессами' },
    { title: 'Первый месяц', desc: 'Работа с наставником, первые задачи, обратная связь' },
    { title: 'Испытательный срок', desc: 'План развития, промежуточная оценка, корректировка целей' },
    { title: 'Полноценный сотрудник', desc: 'Финальная оценка, интеграция в команду, долгосрочный план' },
  ];

  const concepts = [
    { title: 'Адаптация персонала', desc: 'Комплексный процесс ввода новых работников в должность: от знакомства с офисом до выхода на полную производительность. Включает профессиональную, социальную и психологическую адаптацию.' },
    { title: 'Онбординг (Onboarding)', desc: 'Современный термин, означающий полную программу «включения» сотрудника в компанию. Онбординг выходит за рамки простого инструктажа и охватывает корпоративную культуру, ценности, инструменты и связи.' },
    { title: 'Ввод в должность', desc: 'Набор действий по ознакомлению нового сотрудника с обязанностями, правами, стандартами работы и ожидаемыми результатами. Базовый документ — welcome-план и чек-лист должности.' },
    { title: 'Испытательный срок', desc: 'Юридически установленный период (обычно до 3 месяцев), в течение которого работодатель оценивает сотрудника, а сотрудник — компанию. Должен быть наполнен конкретными задачами, а не хаотичными поручениями.' },
    { title: 'Интеграция в корпоративную культуру', desc: 'Процесс усвоения сотрудником ценностей, норм и традиций компании. Без культурной интеграции даже профессиональный сотрудник не становится «своим» и рискует уйти.' },
  ];

  return (
    <section id="what-is" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Что такое адаптация сотрудников
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
          Адаптация — это не «показать стол и выдать пароль от Wi-Fi». Это системный HR-процесс, от которого зависит, останется сотрудник в компании или уйдёт через месяц.
        </p>

        {/* Карточки-концепты */}
        <div className="space-y-6 mb-20">
          {concepts.map((item, i) => (
            <div key={i} className="bg-gray-50 rounded-xl p-6 md:p-8 border border-gray-100 flex flex-col md:flex-row gap-4 md:gap-8 items-start">
              <div className="w-12 h-12 bg-teal-600 rounded-lg flex items-center justify-center flex-shrink-0">
                <span className="text-white font-bold text-lg">{i + 1}</span>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{item.title}</h3>
                <p className="text-gray-600 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Схема: от найма до полноценного сотрудника */}
        <div className="bg-gray-50 rounded-2xl p-8 md:p-12 border border-gray-100">
          <h3 className="text-2xl font-bold text-gray-900 text-center mb-10">
            Путь сотрудника: от найма до полноценной интеграции
          </h3>
          <div className="flex flex-col items-center">
            {schemaSteps.map((step, i) => (
              <div key={i} className="flex flex-col items-center w-full max-w-md">
                <div className="flex items-center gap-4 w-full">
                  <div className="w-14 h-14 bg-teal-600 rounded-xl flex items-center justify-center flex-shrink-0 text-white font-bold text-lg shadow-sm">
                    {i + 1}
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900">{step.title}</h4>
                    <p className="text-sm text-gray-600">{step.desc}</p>
                  </div>
                </div>
                {i < schemaSteps.length - 1 && (
                  <div className="w-0.5 h-10 bg-teal-300 my-2"></div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}